import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../lang";

const links = [
  { href: "#manifeste", key: "manifesto" },
  { href: "#services", key: "services" },
  { href: "#fondateur", key: "approach" },
  { href: "#preuves", key: "proof" },
];

export default function Nav({ onBook }) {
  const { lang, setLang, t } = useLang();
  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed top-0 inset-x-0 z-50 border-b border-edge/70 bg-void/80 backdrop-blur-md"
      data-testid="main-nav"
    >
      <div className="flex h-16 items-center justify-between px-6 md:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-3">
          <span className="font-display text-lg font-semibold tracking-tight text-foreground">
            TERRAIN<span className="text-signal">®</span>
          </span>
          <span className="hidden font-mono text-[10px] tracking-[0.2em] text-muted-foreground lg:inline">
            {t.nav.studio}
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.href}
              data-testid={`nav-link-${l.key}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-200 hover:text-foreground"
            >
              {t.nav[l.key]}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="flex items-center border border-edge font-mono text-[11px]" data-testid="lang-switcher">
            {["fr", "en"].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                data-testid={`lang-toggle-${l}`}
                className={`px-3 py-1.5 uppercase tracking-[0.15em] transition-colors duration-200 ${
                  lang === l ? "bg-foreground text-void" : "text-muted-foreground hover:text-foreground"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <button
            onClick={onBook}
            data-testid="nav-booking-btn"
            className="group flex items-center gap-2 rounded-full bg-signal px-5 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:bg-signalhover"
          >
            {t.nav.book}
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </motion.header>
  );
}
